const MuiButton = {
  variants: [
    {
      props: { variant: 'containedReverse', color: 'primary' },
      style: ({ theme }) => ({
        backgroundColor: theme.palette.common.white,
        color: theme.palette.primary.main,
        '&:hover': {
          backgroundColor: theme.palette.gray.A100,
        },
      }),
    },
    {
      props: { variant: 'secondary', color: 'primary' },
      style: ({ theme }) => ({
        backgroundColor: theme.palette.common.white,
        color: theme.palette.primary.main,
        border: `2px solid ${theme.palette.primary.main}`,
        boxShadow: 'none',
        borderRadius: 8,
        '& .MuiButton-startIcon svg path': {
          fill: theme.palette.primary.main,
        },
        '& .MuiButton-endIcon svg path': {
          fill: theme.palette.primary.main,
        },
        '&:hover': {
          backgroundColor: theme.palette.primary.A100,
        },
        '&:disabled': {
          backgroundColor: theme.palette.gray.A400,
          color: theme.palette.common.white,
          icon: {
            color: theme.palette.common.white,
          },
          borderColor: 'transparent',
        },
      }),
    },
    {
      props: { variant: 'home' },
      style: ({ theme }) => ({
        display: 'flex',
        flexDirection: 'column',
        justifyContent: 'flex-start',
        gap: '8px',
        padding: '16px 8px',
        backgroundColor: theme.palette.common.white,
        borderRadius: 8,
        '& .MuiButton-startIcon': {
          marginLeft: '0px',
          marginRight: '0px',
        },
        [theme.breakpoints.up('desktop')]: {
          flexDirection: 'row',
          gap: '16px',
          padding: '24px 16px 24px 32px',
          '&:hover': {
            backgroundColor: theme.palette.common.white,
            transform: 'scale(1.05)',
          },
        },
      }),
    },
    {
      props: { variant: 'form' },
      style: ({ theme }) => ({
        color: theme.palette.common.white,
        borderRadius: 30,
        backgroundColor: theme.palette.primary.main,
        '&:hover': {
          backgroundColor: theme.palette.primary.A800,
        },
        '&:disabled': {
          backgroundColor: theme.palette.gray.A300,
        },
      }),
    },
    {
      props: { variant: 'white' },
      style: ({ theme }) => ({
        backgroundColor: theme.palette.common.white,
        color: theme.palette.common.black,
        '&:hover': {
          backgroundColor: theme.palette.gray.A100,
        },
      }),
    },
    {
      props: { variant: 'link' },
      style: ({ theme }) => ({
        color: theme.palette.primary.main,
        '&:hover': {
          backgroundColor: 'transparent',
          cursor: 'pointer',
          textDecoration: 'underline',
        },
      }),
    },
    {
      props: { variant: 'underlineLink' },
      style: ({ theme }) => ({
        color: theme.palette.primary.main,
        textDecoration: 'underline',
        '&:hover': {
          backgroundColor: 'transparent',
          cursor: 'pointer',
          textDecoration: 'underline',
        },
      }),
    },
    {
      props: { variant: 'hoverHighlightButton' },
      style: ({ theme }) => ({
        padding: 2,
        width: '50%',
        height: 80,
        backgroundColor: '#F2F2F2',
        '&:hover': {
          backgroundColor: theme.palette.primary.main,
          color: theme.palette.common.white,
        },
        fontSize: { xs: 12, md: 15 },
      }),
    },
    {
      props: { variant: 'paper' },
      style: {
        borderRadius: '4px',
      },
    },
    {
      props: { variant: 'navbarButton' },
      style: ({ theme }) => ({
        backgroundColor: 'transparent',
        boxShadow: 'none',
        color: theme.palette.text.primary,
        textTransform: 'none',
        minWidth: 0,
        '&:hover': {
          backgroundColor: theme.palette.action.hover,
        },
        '& .MuiTypography-root': {
          ...theme.typography.h6,
          color: theme.palette.text.primary,
          overflow: 'hidden',
          textOverflow: 'ellipsis',
          whiteSpace: 'nowrap',
        },
      }),
    },
    {
      props: { variant: 'dropDown' },
      style: ({ theme }) => ({
        justifyContent: 'flex-start',
        color: theme.palette.text.primary,
        fontSize: 12,
        padding: 0,
        '& .MuiButton-startIcon': {
          color: theme.palette.primary.main,
          fontWeigth: 'bold',
          fontSize: 13,
        },
        '& .MuiButton-endIcon': {
          color: theme.palette.primary.main,
        },
      }),
    },
    {
      props: { variant: 'newPrimary' },
      style: ({ theme }) => ({
        color: theme.palette.common.white,
        backgroundColor: theme.palette.primary.main,
        '&:hover': {
          backgroundColor: theme.palette.primary.A800,
        },
        '&:disabled': {
          backgroundColor: theme.palette.gray.A400,
        },
        borderRadius: 8,
        boxShadow: 'none',

      }),
    },
    {
      props: { size: 'small_1' },
      style: {
        fontSize: '14px',
        fontStyle: 'normal',
        lineHeight: '140%',
        padding: '4px 8px',
        height: '36px',
      },
    },
    {
      props: { size: 'medium_1' },
      style: {
        fontSize: '16px',
        padding: '6px 12px',
        minHeight: '32px',
      },
    },
    {
      props: { size: 'medium_2' },
      style: {
        fontSize: '16px',
        padding: '8px 16px',
        minHeight: '36px',
      },
    },
    {
      props: { size: 'large_1' },
      style: {
        fontSize: '18px',
        padding: '10px 20px',
        minHeight: '44px',
      },
    },
    {
      props: { variant: 'onboardingOutlined' },
      style: ({ theme }) => ({
        mx: 'auto',
        height: '100%',
        py: 0,
        fontWeight: 700,
        color: theme.palette.text.primary,
        borderRadius: 8,
        borderWidth: '2px',
        borderStyle: 'solid',
        borderColor: theme.palette.gray.A400,
        backgroundColor: theme.palette.common.white,
        '& .subtitle': {
          color: theme.palette.gray.A400,
        },
        '&:hover': {
          backgroundColor: theme.palette.primary.A100,
        },
        '&.Mui-selected': {
          borderColor: 'transparent',
          color: theme.palette.common.white,
          backgroundColor: theme.palette.primary.main,
          '& .subtitle': {
            color: theme.palette.common.white,
          },
          '&:hover': {
            backgroundColor: theme.palette.primary.main,
          },
        },
      }),
    },
    {
      props: { variant: 'contained', color: 'primary' },
      style: () => ({
        borderRadius: 8,
      }),
    },
    {
      props: { variant: 'quickFilter' },
      style: ({ theme }) => ({
        backgroundColor: theme.palette.common.white,
        color: theme.palette.text.primary,
        boxShadow: 'none',
        border: `1px solid ${theme.palette.primary.main}`,
        '&:hover': {
          backgroundColor: theme.palette.primary.A100,
        },
        '&.Mui-selected': {
          backgroundColor: theme.palette.primary.main,
          color: theme.palette.common.white,
          '&:hover': {
            backgroundColor: theme.palette.primary.A800,
          },
          '& .MuiButton-startIcon svg path': {
            fill: theme.palette.common.white,
          },
        },
      }),
    },
    {
      props: { size: 'adaptative' },
      style: ({ theme }) => ({
        minWidth: 'unset',
        paddingLeft: theme.spacing(1),
        paddingRight: theme.spacing(1),
        paddingTop: theme.spacing(0.5),
        paddingBottom: theme.spacing(0.5),
        height: '100%',
        borderRadius: 8,
        [theme.breakpoints.down('md')]: {
          borderRadius: 16,
        },
      }),
    },
  ],
  styleOverrides: {
    root: {
      py: 2,
      px: 4,
      borderRadius: '8px',
      fontWeight: 600,
    },

    label: {
      height: '100%',
    },
    sizeSmall: {
      padding: '8px 16px',
      height: 'min-content',
    },
  },
};

export default MuiButton;
